// @ts-nocheck
/* eslint-disable */

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.StyledChildrenWrapper = exports.StyledListItemIconWrapper = exports.StyledListItem = void 0;

var _styledComponents = _interopRequireWildcard(require('../../styled-components'));

var _colors = require('../../utils/colors');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc =
            Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(['\n  display: block;\n  width: 100%;\n']);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral([
    '\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  margin: 0 .5em;\n  min-width: 1rem;\n'
  ]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral([
    '\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: ',
    ';\n  ',
    '\n  ',
    '\n  color: ',
    ';\n  overflow: hidden;\n\n  ',
    '\n  ',
    '\n  ',
    '\n'
  ]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(['\n    ', '\n  ']);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(['\n    background: ', ';\n  ']);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(['\n    &:hover {\n      background: ', ';\n      cursor: pointer;\n    }\n  ']);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var hoverStyle = function hoverStyle(props) {
  return (0, _styledComponents.css)(
    _templateObject(),
    (0, _colors.normaliseColor)(props.theme.listItem.hoverBackgroundColor, props.theme)
  );
};

var selectedStyle = function selectedStyle(props) {
  return (0, _styledComponents.css)(
    _templateObject2(),
    (0, _colors.normaliseColor)(props.theme.listItem.selectedBackgroundColor, props.theme)
  );
};

var disabledStyle = function disabledStyle(props) {
  return (0, _styledComponents.css)(_templateObject3(), props.disabled && 'opacity: 0.3;');
};

var StyledListItem = _styledComponents.default.li.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['hasLeftIcon', 'hasRightIcon', 'selected', 'disabled', 'color'].includes(prop);
  }
})(
  _templateObject4(),
  function (props) {
    return props.theme.listItem.padding;
  },
  function (props) {
    return props.hasLeftIcon && 'padding-left: 0;';
  },
  function (props) {
    return props.hasRightIcon && 'padding-right: 0;';
  },
  function (props) {
    return props.color || (0, _colors.normaliseColor)(props.theme.listItem.textColor, props.theme);
  },
  function (props) {
    return props.selected && selectedStyle(props);
  },
  function (props) {
    return props.disabled && disabledStyle(props);
  },
  function (props) {
    return !props.disabled && hoverStyle(props);
  }
);

exports.StyledListItem = StyledListItem;

var StyledListItemIconWrapper = _styledComponents.default.div(_templateObject5());

exports.StyledListItemIconWrapper = StyledListItemIconWrapper;

var StyledChildrenWrapper = _styledComponents.default.div(_templateObject6());

exports.StyledChildrenWrapper = StyledChildrenWrapper;
